module.exports = __webpack_public_path__ + "img/recharge_banner.39eb2ebb.jpg";